module.exports = __webpack_public_path__ + "img/invitation_gift3.bca246de.png";